// 必要なコンポーネントやライブラリをインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー用のフレームコンポーネント
import UMMain from "../organisms/UMMain"; // 資料のメインコンテンツを表示するコンポーネント
import UMIndex from "../molecules/UMIndex"; // 資料の目次を表示するコンポーネント
import { Container, Grid } from '@mui/material'; // Material-UIのコンテナとグリッドレイアウト用コンポーネント

// 資料タイトルを定義（静的な文字列）
const materialTitle: string = "資料タイトル";

/** 
 * 資料テンプレートコンポーネント
 * 資料のメインコンテンツと目次を表示するためのUIを提供
 */
const UserMaterialTemplate = () => {

    return (
        // ユーザー専用フレームで全体をラップ
        <UserFrame title={materialTitle}> {/* タイトルに"資料タイトル"を設定 */}
            {/* グリッドレイアウトを使用して2カラム構成を作成 */}
            <Grid container>
                {/* 左カラム: メインコンテンツ */}
                <Grid xs={12} md={9}> {/* スマホでは全幅、ミドルサイズ以上では9割幅 */}
                    <UMMain /> {/* メインコンテンツ表示 */}
                </Grid>

                {/* 右カラム: 目次 */}
                <Grid xs={12} md={3}> {/* スマホでは全幅、ミドルサイズ以上では3割幅 */}
                    <Container maxWidth='md'> {/* 目次を囲むコンテナ */}
                        <UMIndex /> {/* 目次表示 */}
                    </Container>
                </Grid>
            </Grid>
        </UserFrame>
    )
}

// コンポーネントをエクスポート
export default UserMaterialTemplate;
